import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function CommunitySiteStateHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '195px',
				minWidth: '195px',
				maxWidth: '195px'
			}}>
			Community site state
		</StickyHeader>
	)
}

export function CommunitySiteStateFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunitySiteStateCodeValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySiteStateCodeValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CommunitySiteStateCode ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySiteStateCode: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CommunitySiteStateContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunitySiteStateCodeValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunitySiteStateCode}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}